module.exports = __webpack_public_path__ + "static/media/img_ellipse_305.5260f49a.webp";